// AUTO-GENERATED by packages/db/scripts/port-i18n-m2.ts — do not hand-edit
// structure. Adding a NEW key here is fine (that's the point: code defaults).
// DB rows in `translations` override these at boot, same language only.
//
// Locale: ar

export const ar = {
  app: {
    account: {
      danger_title: 'حذف الحساب',
      delete_button: 'حذف حسابي',
      delete_confirm_label: 'اكتب {word} للتأكيد',
      delete_confirm_word: 'DELETE',
      delete_description:
        'يؤدي هذا إلى إزالة اسمك وبريدك وبيانات دخولك، وإغلاق حسابات أبنائك. لا يمكن التراجع عن ذلك.',
      delete_dialog_title: 'هل تريد حذف حسابك؟',
      delete_error_subscription: 'ألغِ اشتراكك أولاً، ثم عُد لحذف حسابك.',
      delete_kept: 'نحتفظ بسجلات الفواتير كما يقتضي القانون، ولم تعد مرتبطة باسمك.',
      delete_password_label: 'أكّد بكلمة المرور',
      delete_submit: 'حذف نهائي',
      delete_warning: 'هذا الإجراء نهائي. اقرأه بعناية.',
      email_current: 'البريد الحالي',
      email_description:
        'سنرسل رابط تأكيد إلى بريدك الجديد. يبقى بريدك الحالي فعّالاً حتى تضغط عليه.',
      email_error_same: 'هذا بريدك الحالي بالفعل.',
      email_error_taken: 'هذا البريد غير متاح.',
      email_label: 'البريد الإلكتروني الجديد',
      email_sent: 'تفقّد بريدك الجديد لإيجاد رابط التأكيد.',
      email_submit: 'إرسال رابط التأكيد',
      email_title: 'البريد الإلكتروني',
      email_verified_success: 'تم تحديث بريدك الإلكتروني.',
      email_verifying: 'جارٍ تأكيد بريدك الجديد…',
      export_button: 'تنزيل بياناتي',
      export_description: 'نزّل نسخة من بيانات حسابك وسجلات أبنائك وفواتيرك.',
      export_error: 'تعذّر تجهيز الملف. حاول مرة أخرى.',
      export_ready: 'بدأ التنزيل.',
      export_title: 'بياناتك',
      language_description: 'اللغة المستخدمة في التطبيق وفي رسائل البريد.',
      language_title: 'اللغة',
      password_current_label: 'كلمة المرور الحالية',
      password_description: 'تغيير كلمة المرور يُخرجك من جميع الأجهزة الأخرى.',
      password_error_same: 'يجب أن تختلف كلمة المرور الجديدة عن الحالية.',
      password_error_wrong: 'كلمة المرور الحالية غير صحيحة.',
      password_label: 'كلمة المرور الجديدة',
      password_repeat_label: 'أعد كتابة كلمة المرور',
      password_repeat_mismatch: 'كلمتا المرور غير متطابقتين.',
      password_submit: 'تغيير كلمة المرور',
      password_success: 'تم تغيير كلمة المرور.',
      password_title: 'كلمة المرور',
      saved: 'تم الحفظ',
      subtitle: 'إدارة بيانات دخولك ولغتك وبياناتك.',
      title: 'إعدادات الحساب',
    },
    auth: {
      create_account: 'إنشاء الحساب',
      email_label: 'البريد الإلكتروني',
      have_account: 'لديك حسابٌ بالفعل؟',
      magic_link: 'أرسل لي رابط دخولٍ عبر البريد بدلًا من ذلك',
      magic_sent: 'إن كان هذا البريد لدينا، فرابط الدخول في طريقه إليك.',
      marketing_opt_in: 'أرسلوا لي نصائح ومستجدّات القصص من حينٍ لآخر.',
      name_label: 'اسمك',
      no_account: 'جديدٌ على الفجر العربي؟',
      password_hint_parent: '١٠ أحرفٍ على الأقل، تتضمّن حرفًا ورقمًا.',
      password_label: 'كلمة المرور',
      school_tab: 'مدرسة',
      sign_in: 'تسجيل الدخول',
      sign_in_failed: 'البيانات غير متطابقة. تحقّق منها وحاول مرّةً أخرى.',
      sign_in_link: 'تسجيل الدخول',
      sign_up_link: 'أنشئ حساب عائلة',
      signup_subtitle: 'أنشئ حساب وليّ أمر، ثمّ أضف أطفالك بعد الدخول — لا حاجة لبطاقةٍ للبدء.',
      signup_title: 'أنشئ حسابك',
      tab_kid: 'أنا متعلّم',
      tab_parent: 'أنا وليّ أمر',
      username_label: 'اسم المستخدم',
      welcome_subtitle: 'سجّل الدخول لمواصلة رحلة التعلّم.',
      welcome_title: 'أهلًا بعودتك',
    },
    badges: {
      earned_on: 'حصلت عليه في {date}',
      empty: 'لا أوسمة بعد — واصل التعلّم!',
      locked: 'لم تحصل عليه بعد',
      new_badge: 'وسامٌ جديد!',
      subtitle: '{earned} من {total} أوسمة',
      title: 'إنجازاتي',
    },
    billing: {
      activity: 'كل الحركات',
      activity_hide: 'إخفاء الحركات',
      activity_none: 'لا توجد حركات بعد.',
      activity_show: 'عرض كل الحركات',
      back_to_billing: 'العودة إلى الفوترة',
      cancel: 'إلغاء',
      card_brand_unknown: 'بطاقة',
      card_default: 'الافتراضية',
      card_expired: 'منتهية',
      card_expires: 'تنتهي في {month}/{year}',
      card_expiring_soon: 'تنتهي قريبًا',
      card_last4: '{brand} المنتهية بـ {last4}',
      card_make_default: 'اجعلها الافتراضية',
      card_none: 'لم تُحفظ أي بطاقة بعد.',
      card_none_warning: 'لا توجد بطاقة محفوظة. لن يتجدّد اشتراكك بدونها.',
      card_remove: 'إزالة',
      card_remove_confirm: 'هل تريد إزالة {brand} المنتهية بـ {last4}؟',
      card_remove_confirm_body: 'لن تُستخدم هذه البطاقة في التجديدات بعد الآن.',
      card_update: 'تحديث البطاقة',
      card_updated: 'تم تحديث بطاقتك.',
      checkout_canceled: 'لم يكتمل الدفع. لم يتم أي خصم.',
      checkout_success: 'تم استلام الدفعة — اشتراكك مُفعّل.',
      choose: 'اختيار',
      choose_plan: 'اختر خطة',
      coupon_applied: 'قسيمة {code}',
      coupon_label: 'لديك قسيمة؟',
      coupon_placeholder: 'رمز القسيمة',
      currency: 'العملة',
      current_plan: 'خطتك الحالية',
      discount: 'الخصم',
      ends_on: 'ينتهي في {date}',
      invoice_amount: 'المبلغ',
      invoice_date: 'التاريخ',
      invoice_not_found: 'تعذّر العثور على هذه الفاتورة.',
      invoice_number: 'فاتورة {number}',
      invoice_paid_on: 'دُفعت في {date}',
      invoice_plan: 'الخطة',
      invoice_print: 'طباعة',
      invoice_refunded_amount: 'المبلغ المُعاد',
      invoice_status: 'الحالة',
      invoice_view: 'عرض الفاتورة',
      invoices: 'الفواتير',
      monthly: 'شهري',
      most_popular: 'الأكثر شيوعًا',
      no_subscription: 'ليس لديك اشتراك بعد. اختر خطة للبدء.',
      payment_method: 'طريقة الدفع',
      per_month: 'شهر',
      per_year: 'سنة',
      refund_on: 'أُعيد في {date}',
      refund_reason: 'السبب',
      refunds: 'المبالغ المُعادة',
      refunds_none: 'لا توجد مبالغ مُعادة على هذه الفاتورة.',
      renews_on: 'يتجدّد في {date}',
      resume: 'استئناف',
      status_active: 'مُفعّل',
      status_canceled: 'مُلغى',
      status_draft: 'مسودة',
      status_incomplete: 'غير مكتمل',
      status_open: 'مفتوحة',
      status_paid: 'مدفوعة',
      status_partially_refunded: 'مُعاد جزئيًا',
      status_past_due: 'متأخر',
      status_refunded: 'مُعاد بالكامل',
      status_trialing: 'تجريبي',
      status_uncollectible: 'غير محصّلة',
      status_void: 'ملغاة',
      subtotal: 'المجموع الفرعي',
      title: 'الخطة والفوترة',
      total: 'الإجمالي',
      txn_invoice: 'دفعة اشتراك',
      txn_refund: 'مبلغ مُعاد',
      yearly: 'سنوي',
    },
    certificate: {
      awarded_to: 'تُمنَح إلى',
      body: 'لإتمامه بنجاحٍ جميع الدروس البالغ عددها {lessons} في',
      heading: 'شهادة إتمام',
      lessons_done: '{n} دروسٍ مكتملة',
      not_earned: 'أكمل كلّ دروس الوحدة للحصول على هذه الشهادة.',
      print: 'طباعة',
      print_hint: 'نصيحة: اختر «حفظ بصيغة PDF» في نافذة الطباعة للاحتفاظ بنسخة.',
      section_title: 'شهاداتي',
      view: 'عرض',
    },
    common: {
      app_name: 'الفجر العربي',
      cancel: 'إلغاء',
      error_generic: 'حدث خطأٌ ما. حاول مرّةً أخرى.',
      lang_switch_label: 'تغيير اللغة',
      loading: 'جارٍ التحميل…',
      pick_role_subtitle: 'لديك أكثر من دور. اختر واحدًا للمتابعة.',
      pick_role_title: 'اختر كيف تريد المتابعة',
      role_kid: 'المتعلّم',
      role_parent: 'وليّ الأمر',
      role_school_admin: 'مدير المدرسة',
      role_switcher_label: 'تبديل الدور',
      role_teacher: 'المعلّم',
      save: 'حفظ',
      sign_out: 'تسجيل الخروج',
    },
    consent: {
      accept_all: 'قبول الكل',
      analytics_desc: 'تساعدنا على فهم الصفحات والدروس الأكثر فائدة.',
      analytics_label: 'التحليلات',
      body: 'نستخدم ملفات تعريف ارتباط أساسية لتشغيل هذا التطبيق. وبإذنك، نقيس أيضًا كيفية استخدامه وأداء إعلاناتنا. يمكنك تغيير اختيارك في أي وقت.',
      customize: 'تخصيص',
      essential_only: 'الأساسية فقط',
      marketing_desc: 'تتيح لشركائنا الإعلانيين قياس ما إذا كانت إعلاناتهم قد أوصلتك إلينا.',
      marketing_label: 'التسويق',
      save: 'حفظ الخيارات',
      title: 'خصوصيتك',
    },
    kid: {
      all_done_body: 'أنهيت دروسك. عُد لاحقًا للمزيد.',
      all_done_title: 'أنهيت كلّ شيءٍ الآن!',
      assigned_done: 'تمّ',
      assigned_start: 'ابدأ',
      assigned_title: 'مهامّك',
      coming_soon: 'دَرسُك الأوّل قيد التحضير. عُد قريبًا جدًّا!',
      continue_lesson: 'واصل',
      greeting: 'أهلًا {name}!',
      lesson_minutes: 'نحو {n} دقيقة',
      load_error: 'تعذّر تحميل درسك. حدّث الصفحة.',
      start_lesson: 'ابدأ',
      streak: 'سلسلة {n} يومًا',
      todays_plan: 'مغامرة اليوم',
      xp: '{n} نقطة',
    },
    messages: {
      compose_placeholder: 'اكتب رسالة…',
      empty: 'لا محادثات بعد.',
      held_for_review: 'قيد المراجعة',
      message_label: 'الرسالة',
      mode_broadcast: 'إلى فصل',
      mode_direct: 'إلى طالب',
      no_messages_yet: 'لا رسائل بعد',
      observer_badge: 'مُتابَعة',
      pick_class: 'الفصل',
      pick_conversation: 'اختر محادثة لقراءتها.',
      pick_student: 'الطالب',
      read_only: 'هذه المحادثة للقراءة فقط بالنسبة لك.',
      send: 'إرسال',
      send_broadcast: 'إرسال للفصل',
      title: 'الرسائل',
    },
    nav: {
      assignments: 'الواجبات',
      badges: 'أوسمة',
      billing: 'الفوترة',
      classes: 'الفصول',
      home: 'الرئيسية',
      kids: 'الأطفال',
      map: 'الخريطة',
      messages: 'الرسائل',
      overview: 'نظرة عامة',
      plan: 'الخطة',
      profile: 'أنا',
      progress: 'التقدّم',
      settings: 'الإعدادات',
      stories: 'القصص',
      students: 'الطلّاب',
      tasks: 'المهامّ',
      teachers: 'المعلّمون',
      today: 'اليوم',
    },
    notif: {
      bell_label: 'الإشعارات',
      empty: 'لا جديد.',
      push_label: 'الإشعارات الفورية',
      push_off: 'مُعطّلة',
      push_on: 'مُفعّلة',
      title: 'الإشعارات',
    },
    parent: {
      add_kid: 'إضافة طفل',
      add_kid_title: 'إضافة طفل',
      coming_soon_progress:
        'تفاصيل التقدّم والمكافآت قريبًا. أضف أطفالك الآن وسلّمهم الجهاز للبدء.',
      dashboard_subtitle: 'إليك سير تعلّم عائلتك.',
      delete_kid: 'إزالة',
      delete_kid_confirm: 'إزالة {name}؟ سيُؤرشَف تقدّمه ولن يتمكّن من تسجيل الدخول بعد الآن.',
      edit_kid: 'تعديل',
      edit_kid_title: 'تعديل بيانات الطفل',
      field_avatar: 'اختر صورةً رمزية',
      field_display_name: 'اسم الطفل',
      field_grade: 'الصفّ',
      field_password: 'كلمة المرور',
      field_password_hint: '٦ أحرفٍ على الأقل، تتضمّن حرفًا.',
      field_username: 'اسم المستخدم',
      field_username_hint: 'أحرفٌ وأرقامٌ ونقطةٌ وشرطةٌ سفلية. بهذا يسجّلون الدخول.',
      grade_none: 'غير محدّد',
      greeting: 'مرحبًا، {name}',
      kid_cap_note: 'تدعم خطّتك حتى ٣ أطفال.',
      kids_subtitle: 'أضف ملفًّا لكلّ طفل. يسجّلون الدخول باسم مستخدمٍ وكلمة مرور.',
      kids_title: 'أطفالك',
      no_kids: 'لا يوجد أطفالٌ بعد. أضف طفلك الأوّل للبدء.',
      open_as: 'افتح باسم {name}',
      reset_password: 'إعادة تعيين كلمة المرور',
      username_available: 'متاح',
      username_taken: 'محجوز — جرّب أحد هذه:',
    },
    paywall: {
      locked_body: 'أنهيتَ الدروس المجّانية. اطلب من شخصٍ كبير فتح البقية.',
      locked_title: 'واصل التعلّم!',
      nudge_body:
        'يمكن لأطفالك استكشاف الدروس المجّانية الآن. اشترك لفتح كل الوحدات والمواد وأوراق العمل.',
      nudge_cta: 'اطّلع على الخطط',
      nudge_title: 'افتح المنهج كاملًا',
      parent_unlock: 'افتح كل الدروس',
      trial_badge: 'الخطة المجّانية',
    },
    progress: {
      activity_title: 'النشاط (١٢ أسبوعًا)',
      all_time: 'الإجمالي',
      empty_activity: 'لا نشاط بعد — العب درسًا لترى هذا يمتلئ.',
      freeze_used: 'استُخدِم التجميد هذا الأسبوع',
      last_active: 'آخر نشاط',
      last_login: 'آخر دخول',
      lessons: 'الدروس',
      lessons_completed: '{n} مكتمل',
      minutes: '{n} دقيقة',
      never: 'ليس بعد',
      no_kids: 'أضف طفلًا أوّلًا لتتبّع التقدّم.',
      pick_kid: 'اختر طفلًا لعرض تقدّمه.',
      streak: 'السلسلة',
      streak_current: 'سلسلة {n} يوم',
      streak_longest: 'الأفضل: {n} يوم',
      subjects_title: 'حسب المادّة',
      this_month: 'هذا الشهر',
      this_week: 'هذا الأسبوع',
      time_spent: 'الوقت المُستغرَق',
      title: 'تقدّم {name}',
      top_activities_title: 'الأكثر لعبًا',
      track_percent: '{n}% من المسار',
      view: 'عرض التقدّم',
      xp: 'النقاط المكتسبة',
      xp_total: '{n} إجمالًا',
      xp_week: '{n} هذا الأسبوع',
    },
    pwa: {
      install_body: 'أضِفه إلى شاشتك الرئيسية لتجربة التطبيق الكاملة.',
      install_cta: 'تثبيت',
      install_dismiss: 'ليس الآن',
      install_title: 'ثبّت الفجر العربي',
    },
    school: {
      add_class: 'إضافة فصل',
      add_student: 'إضافة طالب',
      add_to_class: 'أضف إلى فصل',
      admin_name: 'اسمك',
      class_name: 'اسم الفصل',
      classes_title: 'الفصول',
      coming_soon: 'إدارة المعلّمين والفصول والفوترة قريبًا مع إصدار المدارس.',
      country: 'الدولة',
      create: 'إنشاء',
      create_account: 'إنشاء حساب المدرسة',
      dashboard_title: 'إدارة المدرسة',
      grade: 'الصفّ',
      have_account: 'لديك حساب؟ سجّل الدخول',
      invite_accept: 'عيّن كلمة المرور وانضمّ',
      invite_invalid: 'رابط الدعوة غير صالح أو منتهي الصلاحية.',
      invite_join_title: 'انضمّ إلى {school}',
      invite_sent: 'أُرسلت الدعوة',
      invite_teacher: 'دعوة معلّم',
      no_class_option: 'بدون فصل',
      no_classes: 'لا فصول بعد. أنشئ فصلك الأوّل.',
      no_students: 'لا طلاب بعد. أضف طالبك الأوّل.',
      no_teachers: 'لا معلّمين بعد. ادعُ معلّمك الأوّل.',
      overview_subtitle: 'أدِر معلّميك وفصولك وطلابك.',
      remove: 'إزالة',
      reset_password: 'إعادة تعيين كلمة المرور',
      school_name: 'اسم المدرسة',
      send_invite: 'إرسال الدعوة',
      signup_subtitle: 'أنشئ حساب مدرسة لدعوة المعلّمين وتسجيل الطلاب.',
      signup_title: 'سجّل مدرستك',
      stat_classes: 'الفصول',
      stat_students: 'الطلاب',
      stat_teachers: 'المعلّمون',
      status_active: 'نشِط',
      status_invited: 'مدعوّ',
      student_count: '{n} طالبًا',
      student_name: 'الاسم',
      student_password: 'كلمة المرور',
      student_username: 'اسم المستخدم',
      students_title: 'الطلاب',
      teacher: 'المعلّم',
      teacher_email: 'البريد الإلكتروني',
      teacher_name: 'الاسم',
      teachers_title: 'المعلّمون',
      unassigned: 'غير مُسنَد',
      username_free: 'متاح',
      username_taken: 'اسم المستخدم مأخوذ',
      welcome: 'مرحبًا، {name}',
    },
    tasks: {
      create: 'إنشاء مهمّة',
      due_date: 'تاريخ التسليم',
      due_prefix: 'التسليم',
      empty_teacher: 'لا مهامّ بعد. أنشئ واحدة أعلاه.',
      mark_done: 'أنهيتُها',
      my_empty: 'لا مهامّ الآن. أحسنت!',
      my_title: 'مهامّي',
      pick_class: 'الفصل',
      remove: 'حذف',
      reopen: 'إعادة فتح',
      status_done: 'تمّت',
      status_in_progress: 'قيد التنفيذ',
      status_open: 'مفتوحة',
      status_verified: 'مؤكّدة',
      title: 'المهامّ',
      title_label: 'المهمّة',
      title_placeholder: 'مثال: أحضر قصّة لمشاركتها يوم الأحد',
      verify: 'تأكيد',
    },
    teacher: {
      assign: 'إسناد',
      assign_lesson: 'إسناد درس',
      assignments_title: 'الواجبات',
      classes_title: 'فصولي',
      coming_soon: 'الفصول والقوائم والواجبات قريبًا مع إصدار المدارس.',
      dashboard_title: 'فصلك الدراسي',
      due_date: 'تاريخ الاستحقاق (اختياري)',
      lessons_done: '{n} درسًا',
      no_assignments: 'لا واجبات بعد. أسنِد درسًا إلى فصل.',
      no_classes: 'لا فصول مُسنَدة إليك بعد. اطلب من مدير المدرسة إسناد فصل.',
      no_students: 'لا طلاب في هذا الفصل بعد.',
      overview_subtitle: 'فصولك وطلابك وواجباتك.',
      pick_class: 'الفصل',
      pick_lesson: 'الدرس',
      roster: 'القائمة',
      unassign: 'إلغاء الإسناد',
      view_progress: 'التقدّم',
      welcome: 'مرحبًا، {name}',
    },
  },
  badge: {
    first_lesson: {
      description: 'أنهيتَ أوّلَ درسٍ لك.',
      title: 'الخُطوةُ الأولى',
    },
    five_lessons: {
      description: 'خمسةُ دروسٍ مكتملة. واصل!',
      title: 'انطلاقة',
    },
    five_perfect: {
      description: 'خمسةُ دروسٍ بعلامةٍ كاملة. مُبهِر!',
      title: 'ذهنٌ حادّ',
    },
    perfect_lesson: {
      description: 'حصلتَ على مئةٍ في درس.',
      title: 'علامةٌ كاملة',
    },
    streak_3: {
      description: 'تعلّمتَ ثلاثةَ أيّامٍ متتاليةً.',
      title: 'ثلاثةٌ تِباعًا',
    },
    streak_30: {
      description: 'ثلاثونَ يومًا تِباعًا. مُثابرةٌ رائعة.',
      title: 'لا يُوقَف',
    },
    streak_7: {
      description: 'سبعةُ أيّامٍ من التعلّمِ تِباعًا!',
      title: 'أسبوعٌ كامل',
    },
    twenty_lessons: {
      description: 'عشرونَ درسًا — قطعتَ شوطًا طويلًا.',
      title: 'مُستكشِف',
    },
    unit_master: {
      description: 'أنهيتَ كلَّ دروسِ وحدةٍ كاملة.',
      title: 'مُتقِنُ الوحدة',
    },
    xp_100: {
      description: 'جمعتَ أوّلَ مئةِ نقطة.',
      title: 'مئة',
    },
    xp_500: {
      description: 'خمسُمئةِ نقطةٍ مجموعة!',
      title: 'بَطَل',
    },
  },
  content: {
    common: {
      captions: 'التسميات التوضيحيّة',
      listen_choose: 'استمع ثمّ اختر',
      play_audio: 'استمع',
      quiz_title: 'تحقّق سريع',
      tap_match: 'طابق بين كلّ زوج',
    },
    drag_sort: {
      all_sorted: 'تمّ التصنيف!',
      instruction: 'صنّف كلّ كلمةٍ في مجموعتها الصحيحة',
    },
    fill_blank: {
      blank_label: 'الكلمة الناقصة',
      instruction: 'أكمل الفراغات',
    },
    letter_trace: {
      canvas_label: 'تتبّع حرف {glyph}',
      clear: 'مسح',
    },
    player: {
      back_home: 'العودة للرئيسية',
      continue: 'متابعة',
      correct: 'أحسنت!',
      done_subtitle: 'قمت بعملٍ رائعٍ اليوم.',
      done_title: 'اكتمل الدرس!',
      empty: 'لا يحتوي هذا الدرس على أنشطةٍ بعد.',
      error: 'تعذّر الحفظ. اضغط للمحاولة مجدّدًا.',
      exit: 'الخروج من الدرس',
      finish: 'إنهاء',
      saving: 'جارٍ الحفظ…',
      stat_score: 'النتيجة',
      stat_streak: 'السلسلة',
      stat_xp: 'نقاط',
      streak_days: '{n} يوم',
      try_again_feedback: 'ليست تمامًا — واصل!',
    },
    printable: {
      download: 'حمّل ورقة العمل',
    },
    read_aloud: {
      mode_partial: 'جزئي',
      mode_with: 'كامل',
      mode_without: 'بدون',
      tashkeel_label: 'التشكيل',
    },
    record_repeat: {
      again: 'سجّل مجدّدًا',
      playback: 'استمع لتسجيلي',
      say_this: 'انطق هذه بصوتٍ عالٍ',
      start: 'سجّل',
      stop: 'أوقف',
      unsupported: 'التسجيل غير متاحٍ هنا — لا بأس، اضغط متابعة.',
    },
    story_scene: {
      new_words: 'كلماتٌ جديدة',
    },
  },
  notif: {
    message_broadcast_body: 'نشر {sender} رسالة لفصلك.',
    message_broadcast_title: 'إعلان للفصل',
    message_observed_body: 'أرسل {sender} رسالة في محادثة طفلك.',
    message_observed_title: 'رسالة جديدة لطفلك',
    message_received_body: 'أرسل لك {sender} رسالة.',
    message_received_title: 'رسالة جديدة',
    task_assigned_body: 'لديك مهمّة جديدة: {title}',
    task_assigned_title: 'مهمّة جديدة',
    task_completed_body: 'وضع طالب علامة «تمّت» على «{title}».',
    task_completed_title: 'اكتملت مهمّة',
  },
  plan: {
    family_free_name: 'المجاني',
    family_free_tagline: 'دروس مجانية، طفل واحد، دون بطاقة.',
    family_name: 'العائلة',
    family_plus_name: 'العائلة+',
    family_plus_tagline: 'كل شيء، مع جلسة مباشرة شهرية.',
    family_starter_name: 'المبتدئ',
    family_starter_tagline: 'طفل واحد، أساسيات العربية.',
    family_tagline: 'حتى ٤ أطفال، كل المواد.',
    feat: {
      '1500_students': 'حتى ١٥٠٠ طالب',
      '150_students': 'حتى ١٥٠ طالبًا',
      '20_teachers': '٢٠ معلّمًا',
      '500_students': 'حتى ٥٠٠ طالب',
      '5_teachers': '٥ معلّمين',
      all_subjects: 'كل المواد',
      arabic_only: 'منهج العربية',
      basic_dashboards: 'لوحات أساسية',
      custom_curriculum: 'ربط منهج مخصّص',
      dedicated_csm: 'مدير نجاح مخصّص',
      four_kids: 'حتى ٤ أطفال',
      free_lessons: 'دروس مجانية',
      full_teacher_tools: 'أدوات المعلّم الكاملة',
      live_session: 'جلسة مباشرة شهرية',
      one_child: 'طفل واحد',
      printables: 'أوراق عمل للطباعة',
      priority_support: 'دعم ذو أولوية',
      progress: 'لوحة التقدّم',
      white_label: 'بوابة بعلامتكم',
    },
    school_premium_name: 'المدرسة — بريميوم',
    school_premium_tagline: 'علامة خاصة، منهج مخصّص.',
    school_standard_name: 'المدرسة — قياسي',
    school_standard_tagline: 'حتى ٥٠٠ طالب، أدوات كاملة.',
    school_starter_name: 'المدرسة — مبتدئ',
    school_starter_tagline: 'حتى ١٥٠ طالبًا.',
  },
  ui: {
    auth: {
      sign_in: 'تسجيل الدخول',
    },
    brand: {
      product_name: 'الفجر العربي',
      tagline: 'العربيّة تنبض بالحياة للأطفال',
    },
    language: {
      arabic: 'العربية',
      english: 'English',
      switch: 'تغيير اللغة',
    },
  },
} as const;

export default ar;
